var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-qa":"errorhandler-div-14ml4d"}},[(_vm.config.component)?_c(_vm.config.component,{tag:"component",attrs:{"config":_vm.getSettings()}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }